"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObservableCreate = ObservableCreate;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _ = require(".");

/**
 * Wrapper for rxjs Observable.create with improved error handling and
 * aborting support
 * @param func - observer function, could be async
 */
function ObservableCreate(func, signal) {
  return _rxjs.Observable.create(function (observer) {
    try {
      var ret = func(observer); // catch async errors

      if (ret && ret.catch) {
        ret.catch(function (error) {
          return observer.error(error);
        });
      }
    } catch (error) {
      // catch sync errors
      observer.error(error);
    }
  }).pipe((0, _operators.takeUntil)((0, _.observeAbortSignal)(signal)));
}